import { styled } from '@mui/material';
import { ALLOCATIONS_DRAFT, ALLOCATIONS_FINAL, ALLOCATIONS_PUBLISHED } from 'common/constants/allocations';
import { ALLOCATION_STATUS } from './common/constants';

export const StyledGrid = styled('span')(({ theme }) => ({
  backgroundColor: theme.palette.common.black,
  borderRadius: theme.spacing(0.8),
  display: 'inline-block',
  margin: `0 ${theme.spacing(1)}`,
  padding: `${theme.spacing(0.3)} ${theme.spacing(1)}`,
  textAlign: 'center',

  [`&.${ALLOCATION_STATUS[ALLOCATIONS_DRAFT]}`]: {
    backgroundColor: theme.palette.grey[100],
  },

  [`&.${ALLOCATION_STATUS[ALLOCATIONS_PUBLISHED]}`]: {
    backgroundColor: theme.palette.primary.main,
  },

  [`&.${ALLOCATION_STATUS[ALLOCATIONS_FINAL]}`]: {
    backgroundColor: theme.palette.error.main,
  },
  '&.ready-for-audit': {
    backgroundColor: theme.palette.primary.main,
  },
  '&.draft': {
    backgroundColor: theme.palette.grey[100],
  },
  '&.none': {
    display: 'none',
  },
}));

export const StyledTypography = styled('span')(({ theme }) => ({
  color: theme.palette.common.white,
  fontSize: theme.spacing(1.5),
  lineHeight: 'normal',
  margin: 0,
  textTransform: 'uppercase',

  [`&.${ALLOCATION_STATUS[ALLOCATIONS_DRAFT]}`]: {
    color: theme.palette.grey[400],
  },
  '&.draft': {
    color: theme.palette.grey[400],
  },
}));
